import "@/components/Charts/charts.scss";
import KRentalPickupsCharts from "./Charts";
import ReportChips from "kinnect-general/reports/ReportChips";
import ReportFilters from "kinnect-general/reports/ReportFilters";
import ReportHeader from "kinnect-general/reports/ReportHeader";
import { FetchesData, Reportable } from "kinnect-mixins";
import { KDatePicker } from "kinnect-general";
import { VCard, VCardText } from "vuetify/lib";
import { YardRentalPickupReport } from "kinnect-models";

export default {
	name: "RentalPickupsReport",

	mixins: [
		FetchesData,
		Reportable
	],

	data: () => ( {
		rentalPickupsReport: {}
	} ),

	methods: {
		saveReportFilters( props ) {
			const initialStartDate = this.startDate;
			const initialEndDate = this.endDate;

			this.startDate = props.startDate;
			this.endDate = props.endDate;

			if ( this.startDate !== initialStartDate
				|| this.endDate !== initialEndDate
			) {
				this.fetchReport();
			}
		},

		async fetchReport() {
			this.rentalPickupsReport = await YardRentalPickupReport.params( {
				startDate: this.startDate,
				endDate: this.endDate
			} ).first();
		},

		async fetch() {
			await this.fetchReport();
		}
	},

	render() {
		return <VCard loading={this.$wait.is( "get rental pickup reports" ) ? "link" : false}>
			<ReportHeader>
				<ReportFilters
					filters={[
						{
							key: "startDate",
							value: this.startDate
						},
						{
							key: "endDate",
							value: this.endDate
						}
					]}
					onSave={this.saveReportFilters}
					scopedSlots={{
						"filter.startDate": props =>
							<KDatePicker
								textFieldProps={{
									label: "Start Date*",
									required: true
								}}
								vModel={props.model}
							></KDatePicker>,

						"filter.endDate": props =>
							<KDatePicker
								textFieldProps={{
									label: "End Date*",
									required: true
								}}
								vModel={props.model}
							></KDatePicker>
					}}
				></ReportFilters>

				<ReportChips
					cols={12}
					sm="auto"
					filters={[
						{
							name: "Start Date",
							value: this.startDate
						},
						{
							name: "End Date",
							value: this.endDate
						}
					]}
				></ReportChips>
			</ReportHeader>

			<VCardText>
				<KRentalPickupsCharts
					report={this.rentalPickupsReport}
				></KRentalPickupsCharts>
			</VCardText>
		</VCard>;
	}
};
